import React from "react";
import { useState } from "react";

import { createStyles, makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

import { Box, Snackbar } from "@mui/material";

import CadernoLayout from "../../../Styles/layout/cadernoLayout";
import { CabecalhoForm } from "./cabecalho";
import { AnaliseTerrasForm } from "./analiseterra";
import { CustomThemeProvider } from "../../../Styles/theme/customThemeprovider";
import { RegistoAtividades } from "./registoatividades";
import BeneficiarioNomeIdAlinhadoDireita from "../../../Componentes_modulo/Beneficiario_nome_id_alinhado_direita";
import { IAnaliseTerras, ICabecalho5B, IPage5B, IPage5B_Two } from "../../../Interfaces/cadernos/caderno5/interfaces5B";
import { Alert } from "../../../Components/Alert/Alert";
import { cores } from "../../../Func_genericas/valores_estaticos";

import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { FilterByData } from "../../../Func_genericas/filter_by_data";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
    },
    contents: {
      flexGrow: 1,
      padding: theme.spacing(0),
    },
    toolbars: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(2, 3),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
  })
);


export default function RegAtividades() {
  const classes = useStyles();

  const [message, setMessage] = React.useState<string>("");

  const [obj_anexo_cabecalho_selecionado, set_obj_anexo_cabecalho_selecionado] = useState<ICabecalho5B | undefined>();


  const [openSnackSuccess, setOpenSnackSuccess] = React.useState<boolean>(false);
  const [openSnackError, setOpenSnackError] = React.useState<boolean>(false);


  const [rowsAtividades, setRowsAtividades] = useState<IPage5B[]>([]);
  const [rowsAtividades_filtrada, setRowsAtividades_filtrada] = useState<IPage5B[]>([]);






  const [flag_caderno_5_existe, set_flag_caderno_5_existe] = useState<boolean>(true);


  return (
    <CustomThemeProvider>
      <div className={classes.root}>
        <CadernoLayout title="5B - Registo das atividades" />
        <main className={classes.contents}>
          <div className={classes.toolbars} />
          <Box width="80%" margin="auto">
            <BeneficiarioNomeIdAlinhadoDireita />
          </Box>

         
            <FilterByData
              listas={[
                {
                  lista_original: rowsAtividades,
                  set_lista_filtrada: setRowsAtividades_filtrada,
                  campoData: "data",
                },
               
              ]}
            />
          <Snackbar
            open={openSnackSuccess}
            autoHideDuration={2000}
            onClose={() => setOpenSnackSuccess(false)}
          >
            <Alert
              onClose={() => setOpenSnackSuccess(false)}
              severity="success"
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>
          <Snackbar
            open={openSnackError}
            autoHideDuration={2000}
            onClose={() => setOpenSnackError(false)}
          >
            <Alert
              onClose={() => setOpenSnackError(false)}
              severity="error"
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>
          {

            flag_caderno_5_existe === true ?
              <div style={{
                background: cores.cor5,
                flex: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: 'center',
                alignSelf: 'center',
                justifySelf: 'center',
                width: '98%',
                borderRadius: 3,
                height: 60,
                fontWeight: 'bold',
                marginTop: 10,
                marginBottom: 10,


              }}>
                <div style={{
                  paddingRight: 30,
                  paddingLeft: 30,
                }}>
                  <WarningAmberRoundedIcon />


                </div>

                O Caderno 5 - Registo de Operações Culturais está preenchido, sendo assim não necessário preencher este caderno.
                <div style={{
                  paddingRight: 30,
                  paddingLeft: 30,
                }}>
                  <WarningAmberRoundedIcon />
                </div>
              </div>
              : <></>}

          <Box style={{ width: "100%", height: "auto" }}>
            <CabecalhoForm
              obj_anexo_cabecalho_selecionado={obj_anexo_cabecalho_selecionado}
              set_obj_anexo_cabecalho_selecionado={set_obj_anexo_cabecalho_selecionado}
              set_flag_caderno_5_existe={set_flag_caderno_5_existe}
            />
          </Box>
          {
            obj_anexo_cabecalho_selecionado !== undefined ?



              <>
                <AnaliseTerrasForm
                  setOpenSnackSuccess={setOpenSnackSuccess}
                  setOpenSnackError={setOpenSnackError}
                  setMessage={setMessage}
                  idCabecalho={obj_anexo_cabecalho_selecionado?.id_registo_activi}
                />

                <RegistoAtividades
                  setOpenSnackSuccess={setOpenSnackSuccess}
                  setOpenSnackError={setOpenSnackError}
                  setMessage={setMessage}
                  idCabecalho={obj_anexo_cabecalho_selecionado?.id_registo_activi}
                  setRowsAtividades={setRowsAtividades}
                  rowsAtividades={rowsAtividades}
                  setRowsAtividades_filtrada={setRowsAtividades_filtrada}
                  rowsAtividades_filtrada={rowsAtividades_filtrada}
                />

              </>
              :
              <></>
          }


        </main>
      </div>
    </CustomThemeProvider>
  );
}
